import React, { useState } from 'react';
import {
  Dimensions,
  StyleSheet,
  Text,
  TextInput,
  TouchableOpacity,
  View,
} from 'react-native';
import MyRadioButton from './MyRadioButton';
import MyMessagePopup from './MyMessagePopup';
import { LocStr } from '../utils/Utils';
import {
  cancel_str,
  enter_valid_password,
  enter_valid_username,
  ok_str,
  Password_str,
  Username_str,
} from '../utils/DictionaryManagementUtils';

//= ========================================================================

const MyEditUserPopup = ({
  onValueChanged,
  onCanceled,
  userInfo,
  isNew,
  editorIsAdmin,
  language,
}) => {
  const screenWidth = Dimensions.get('window').width;
  const screenHeight = Dimensions.get('window').height;

  let textInput2;
  let textInput3;
  let textInput4;
  let textInput5;
  let textInput6;
  let textInput7;
  let textInput8;

  const [state, setState] = useState(userInfo);

  const [messagePopupState, setMessagePopupState] = useState({
    isMessageVisible: false,
    title: '',
  });

  //= =======================================================================================================

  const isPhoneValid = (phone) => phone !== null && phone !== 'undefined' && phone.length >= 6;

  const isEmailValid = (email) => {
    const expression = /(?!.*\.{2})^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([\t]*\r\n)?[\t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([\t]*\r\n)?[\t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
    return expression.test(email.toLowerCase());
  };

  const onUpdatePressed = () => {
    if (state.userFullname.length <= 0) {
      const txt = LocStr('Please enter a valid name', language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
      return;
    }
    if (state.userInstitute.length <= 0) {
      const txt = LocStr('Please enter a valid bank/company name', language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
      return;
    }
    if (!isEmailValid(state.userEmail)) {
      const txt = LocStr('Please enter a valid email address', language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
      return;
    }
    if (!isPhoneValid(state.userPhone)) {
      const txt = LocStr('Please enter a valid phone number', language);
      setMessagePopupState({ isMessageVisible: true, title: txt });
      return;
    }
    if (editorIsAdmin) {
      if (state.userUsername.length < 4) {
        const txt = LocStr(enter_valid_username, language);
        setMessagePopupState({ isMessageVisible: true, title: txt });
        return;
      }
      if (state.userPassword.length > 0 && state.userPassword.length < 4) {
        const txt = LocStr(enter_valid_password, language);
        setMessagePopupState({ isMessageVisible: true, title: txt });
        return;
      }
      if (state.userType !== 'admin' && state.userType !== 'user') {
        const txt = LocStr('Please select a user type', language);
        setMessagePopupState({ isMessageVisible: true, title: txt });
        return;
      }
    }

    onValueChanged(state, isNew);
  };

  //= =======================================================================================================

  return (
    <View
      style={{
        width: screenWidth,
        height: screenHeight - 60 - 73,
        justifyContent: 'center',
        position: 'absolute',
      }}
    >
      <View
        style={{
          width: 500,
          /* height:200, */ alignSelf: 'center',
          backgroundColor: '#d9d9d9',
          borderRadius: 8,
          shadowColor: '#000',
          shadowOffset: { width: 0, height: 2 },
          shadowOpacity: 0.22,
          shadowRadius: 12,
        }}
      >
        <View
          style={{
            /* width:398,height:198, height:198,position:'absolute' */
            flexDirection: 'column',
            margin: 1,
            backgroundColor: '#fff',
            borderRadius: 6,
          }}
        >
          {/* -----   full name   ----- */}

          <View
            style={{ alignSelf: 'center', marginTop: 40, flexDirection: 'row' }}
          >
            <Text style={styles.lblTitle}>{LocStr('Name:', language)}</Text>

            <View
              style={{
                width: 300,
                height: 27,
                marginLeft: 10,
                borderRadius: 3,
                backgroundColor: '#a9a9a9',
              }}
            >
              <TextInput
                style={{
                  margin: 1,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  borderBottomWidth: 4,
                  borderTopWidth: 4,
                  borderRightWidth: 4,
                  borderLeftWidth: 4,
                  borderColor: '#fff',
                }}
                value={state.userFullname}
                multiline={false}
                selectTextOnFocus
                maxLength={100}
                onChangeText={(newText) => {
                  // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                  {
                    setState({ ...state, userFullname: newText });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.nativeEvent.key === 'Enter') {
                    textInput3.focus();
                  }
                }}
                ref={(input) => {
                  textInput2 = input;
                }}
              />
            </View>
          </View>

          <View
            style={{
              alignSelf: 'center',
              width: 420,
              marginTop: 12,
              height: 1,
              backgroundColor: '#e2e8f0',
            }}
          />

          {/* -----   Institute   ----- */}

          <View
            style={{ alignSelf: 'center', marginTop: 12, flexDirection: 'row' }}
          >
            <Text style={styles.lblTitle}>
              {LocStr('Bank/Company:', language)}
            </Text>

            <View
              style={{
                width: 300,
                height: 27,
                marginLeft: 10,
                borderRadius: 3,
                backgroundColor: '#a9a9a9',
              }}
            >
              <TextInput
                style={{
                  margin: 1,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  borderBottomWidth: 4,
                  borderTopWidth: 4,
                  borderRightWidth: 4,
                  borderLeftWidth: 4,
                  borderColor: '#fff',
                }}
                value={state.userInstitute}
                multiline={false}
                selectTextOnFocus
                maxLength={100}
                onChangeText={(newText) => {
                  // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                  {
                    setState({ ...state, userInstitute: newText });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.nativeEvent.key === 'Enter') {
                    textInput4.focus();
                  }
                }}
                ref={(input) => {
                  textInput3 = input;
                }}
              />
            </View>
          </View>

          {/* -----   role   ----- */}

          <View
            style={{ alignSelf: 'center', marginTop: 8, flexDirection: 'row' }}
          >
            <Text style={styles.lblTitle}>{LocStr('Role:', language)}</Text>

            <View
              style={{
                width: 300,
                height: 27,
                marginLeft: 10,
                borderRadius: 3,
                backgroundColor: '#a9a9a9',
              }}
            >
              <TextInput
                style={{
                  margin: 1,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  borderBottomWidth: 4,
                  borderTopWidth: 4,
                  borderRightWidth: 4,
                  borderLeftWidth: 4,
                  borderColor: '#fff',
                }}
                value={state.userRole}
                multiline={false}
                selectTextOnFocus
                maxLength={100}
                onChangeText={(newText) => {
                  // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                  {
                    setState({ ...state, userRole: newText });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.nativeEvent.key === 'Enter') {
                    textInput5.focus();
                  }
                }}
                ref={(input) => {
                  textInput4 = input;
                }}
              />
            </View>
          </View>

          <View
            style={{
              alignSelf: 'center',
              width: 420,
              marginTop: 12,
              height: 1,
              backgroundColor: '#e2e8f0',
            }}
          />

          {/* -----   email   ----- */}

          <View
            style={{ alignSelf: 'center', marginTop: 12, flexDirection: 'row' }}
          >
            <Text style={styles.lblTitle}>{LocStr('Email:', language)}</Text>

            <View
              style={{
                width: 300,
                height: 27,
                marginLeft: 10,
                borderRadius: 3,
                backgroundColor: '#a9a9a9',
              }}
            >
              <TextInput
                style={{
                  margin: 1,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  borderBottomWidth: 4,
                  borderTopWidth: 4,
                  borderRightWidth: 4,
                  borderLeftWidth: 4,
                  borderColor: '#fff',
                }}
                value={state.userEmail}
                multiline={false}
                selectTextOnFocus
                maxLength={100}
                onChangeText={(newText) => {
                  // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                  {
                    setState({ ...state, userEmail: newText });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.nativeEvent.key === 'Enter') {
                    textInput6.focus();
                  }
                }}
                ref={(input) => {
                  textInput5 = input;
                }}
              />
            </View>
          </View>

          {/* -----   phone   ----- */}

          <View
            style={{ alignSelf: 'center', marginTop: 8, flexDirection: 'row' }}
          >
            <Text style={styles.lblTitle}>{LocStr('Phone:', language)}</Text>

            <View
              style={{
                width: 300,
                height: 27,
                marginLeft: 10,
                borderRadius: 3,
                backgroundColor: '#a9a9a9',
              }}
            >
              <TextInput
                style={{
                  margin: 1,
                  borderRadius: 2,
                  backgroundColor: '#fff',
                  borderBottomWidth: 4,
                  borderTopWidth: 4,
                  borderRightWidth: 4,
                  borderLeftWidth: 4,
                  borderColor: '#fff',
                }}
                value={state.userPhone}
                multiline={false}
                selectTextOnFocus
                maxLength={100}
                onChangeText={(newText) => {
                  // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                  {
                    setState({ ...state, userPhone: newText });
                  }
                }}
                onKeyPress={(e) => {
                  if (e.nativeEvent.key === 'Enter') {
                    if (editorIsAdmin) textInput7.focus();
                  }
                }}
                ref={(input) => {
                  textInput6 = input;
                }}
              />
            </View>
          </View>

          {editorIsAdmin ? (
            <View
              style={{
                alignSelf: 'center',
                width: 420,
                marginTop: 12,
                height: 1,
                backgroundColor: '#e2e8f0',
              }}
            />
          ) : null}

          {/* -----   username   ----- */}

          {editorIsAdmin ? (
            <View
              style={{
                alignSelf: 'center',
                marginTop: 12,
                flexDirection: 'row',
              }}
            >
              <Text style={styles.lblTitle}>
                {LocStr(Username_str, language)}
              </Text>

              <View
                style={{
                  width: 300,
                  height: 27,
                  marginLeft: 10,
                  borderRadius: 3,
                  backgroundColor: '#a9a9a9',
                }}
              >
                <TextInput
                  style={{
                    margin: 1,
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    borderBottomWidth: 4,
                    borderTopWidth: 4,
                    borderRightWidth: 4,
                    borderLeftWidth: 4,
                    borderColor: '#fff',
                  }}
                  value={state.userUsername}
                  multiline={false}
                  selectTextOnFocus
                  maxLength={100}
                  onChangeText={(newText) => {
                    // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                    {
                      setState({ ...state, userUsername: newText });
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.nativeEvent.key === 'Enter') {
                      textInput8.focus();
                    }
                  }}
                  ref={(input) => {
                    textInput7 = input;
                  }}
                />
              </View>
            </View>
          ) : null}

          {/* -----   password   ----- */}

          {editorIsAdmin ? (
            <View
              style={{
                alignSelf: 'center',
                marginTop: 8,
                flexDirection: 'row',
              }}
            >
              <Text style={styles.lblTitle}>
                {LocStr(Password_str, language)}
              </Text>

              <View
                style={{
                  width: 300,
                  height: 27,
                  marginLeft: 10,
                  borderRadius: 3,
                  backgroundColor: '#a9a9a9',
                }}
              >
                <TextInput
                  style={{
                    margin: 1,
                    borderRadius: 2,
                    backgroundColor: '#fff',
                    borderBottomWidth: 4,
                    borderTopWidth: 4,
                    borderRightWidth: 4,
                    borderLeftWidth: 4,
                    borderColor: '#fff',
                  }}
                  value={state.userPassword}
                  multiline={false}
                  selectTextOnFocus
                  maxLength={100}
                  onChangeText={(newText) => {
                    // if (!newText || newText.match(/^\d{1,}(\.\d{0,2})?$/))
                    {
                      setState({ ...state, userPassword: newText });
                    }
                  }}
                  onKeyPress={(e) => {
                    if (e.nativeEvent.key === 'Enter') {
                    }
                  }}
                  ref={(input) => {
                    textInput8 = input;
                  }}
                />
              </View>
            </View>
          ) : null}

          {/* -----   type   ----- */}

          {editorIsAdmin ? (
            <View
              style={{
                alignSelf: 'center',
                marginTop: 8,
                flexDirection: 'row',
              }}
            >
              <Text style={styles.lblTitle}>
                {LocStr('User type:', language)}
              </Text>

              <View
                style={{
                  width: 300,
                  height: 20,
                  marginLeft: 10,
                  flexDirection: 'row',
                  alignItems: 'center',
                }}
              >
                <View style={{ height: 20, marginLeft: 0 }}>
                  <MyRadioButton
                    style={{ height: 20 }}
                    title={LocStr('PayKey team', language)}
                    value={state.userType === 'admin'}
                    onPressed={() => {
                      setState({ ...state, userType: 'admin' });
                    }}
                  />
                </View>

                <View style={{ height: 20, marginLeft: 20 }}>
                  <MyRadioButton
                    style={{ height: 20 }}
                    title={LocStr('Customer', language)}
                    value={state.userType === 'user'}
                    onPressed={() => {
                      setState({ ...state, userType: 'user' });
                    }}
                  />
                </View>
              </View>
            </View>
          ) : null}

          {/* -----   buttons   ----- */}

          <View
            style={{
              alignSelf: 'center',
              marginTop: 40,
              height: 36,
              flexDirection: 'row',
            }}
          >
            <TouchableOpacity
              style={{
                width: 100,
                height: 36,
                backgroundColor: '#008cff',
                borderRadius: 8,
              }}
              onPress={() => {
                onCanceled();
              }}
            >
              <View
                style={{
                  width: 96,
                  height: 32,
                  position: 'absolute',
                  margin: 2,
                  backgroundColor: '#008cff',
                  borderRadius: 6,
                }}
              >
                <Text style={[styles.lblTitle16, { marginTop: 5 }]}>
                  {LocStr(cancel_str, language)}
                </Text>
              </View>
            </TouchableOpacity>

            <TouchableOpacity
              style={{
                marginLeft: 420 - 100 - 100,
                width: 100,
                height: 36,
                backgroundColor: '#008cff',
                borderRadius: 8,
              }}
              onPress={() => {
                onUpdatePressed();
              }}
            >
              <View
                style={{
                  width: 96,
                  height: 32,
                  position: 'absolute',
                  margin: 2,
                  backgroundColor: '#008cff',
                  borderRadius: 6,
                }}
              >
                <Text style={[styles.lblTitle16, { marginTop: 5 }]}>
                  {LocStr('Update', language)}
                </Text>
              </View>
            </TouchableOpacity>
          </View>

          <View style={{ width: 1, height: 20 }} />
        </View>
      </View>

      {messagePopupState.isMessageVisible ? (
        <MyMessagePopup
          parentWidth={screenWidth}
          onOkPressed={() => setMessagePopupState({ isMessageVisible: false, title: '' })}
          okTitle={LocStr(ok_str, language)}
          message={messagePopupState.title}
          language={language}
        />
      ) : null}
    </View>
  );
};

const styles = StyleSheet.create({
  lblTitle16: {
    width: 96,
    fontFamily: 'Rubik-Medium',
    fontSize: 18,
    color: '#fff',
    textAlign: 'center',
    position: 'absolute',
  },
  lblTitle: {
    width: 110,
    marginTop: 4,
    fontFamily: 'Rubik-Regular',
    fontSize: 14,
    color: '#001a2f',
    // position: 'absolute',
  },
});

export default MyEditUserPopup;
